import { Box, CircularProgress, Typography } from '@mui/material';

export interface BglLoadingProps {
  className?: string;
  message?: string;
}

export const BglLoading = (props: BglLoadingProps) => {
  return (
    <Box 
      className={props.className}
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        gap: 2
      }}
    >
      <CircularProgress size={60} />
      {props.message && (
        <Typography variant="bglBody2" color="text.secondary">
          {props.message}
        </Typography>
      )}
    </Box>
  );
};